import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "no-results-container"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = { class: "buttons-container" };
const _hoisted_5 = {
    class: "btn btn-cta primary-cta stat-button-link",
    "data-loc": "vehicle save header",
    href: "/searchnew.aspx"
};
const _hoisted_6 = {
    class: "btn btn-cta secondary-cta stat-button-link",
    "data-loc": "vehicle save header",
    href: "/searchused.aspx"
};
import { computed } from "vue";
import carSvgPath from "@/assets/noResultsCarImage.svg";
import rvSvgPath from "@/assets/noResultsRvImage.svg";
export default /*@__PURE__*/ _defineComponent({
    __name: 'noSavedVehicles',
    props: {
        translations: {}
    },
    setup(__props) {
        const props = __props;
        const isRvIndustry = computed(() => {
            const resources = props.translations?.resources;
            return resources && resources["RvIndustry"]?.toLowerCase() === "true";
        });
        const selectedSvgSrc = computed(() => (isRvIndustry.value ? rvSvgPath : carSvgPath));
        const noSavedVehiclesText = computed(() => {
            const resources = props.translations?.resources;
            if (!resources)
                return "";
            if (isRvIndustry.value) {
                return resources["comment_noSavedRvs"] ?? "";
            }
            return resources["comment_noSavedVehicles"] ?? "";
        });
        return (_ctx, _cache) => {
            return (__props.translations)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("img", {
                        src: selectedSvgSrc.value,
                        class: "no-results-image",
                        alt: ""
                    }, null, 8 /* PROPS */, _hoisted_2),
                    _createElementVNode("div", {
                        class: "text-container",
                        innerHTML: noSavedVehiclesText.value
                    }, null, 8 /* PROPS */, _hoisted_3),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("a", _hoisted_5, _toDisplayString(`${props.translations?.resources["label_shop"]} ${props.translations?.resources["label_new"]}`), 1 /* TEXT */),
                        _createElementVNode("a", _hoisted_6, _toDisplayString(`${props.translations?.resources["label_shop"]} ${props.translations?.resources["label_used"]}`), 1 /* TEXT */)
                    ])
                ]))
                : _createCommentVNode("v-if", true);
        };
    }
});
